import styled from 'styled-components';

export const Value = styled.div`
  font-size: 14px;
  line-height: 40px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
`;

export const Last = styled.div`
  font-size: 14px;
  margin-left: 5px;
  font-weight: bold;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  height: 100%;
  /* max-width: 100%; */
  /* width: ${(props) => props.minWidth ?? 'auto'}; */
`;
